/**
 * GameRecoveryController
 *
 */
(function () {
  class GameRecoveryController {
    constructor() {
      this._task = undefined;
      this._commandsToSend = [];
    }

    initialise() {
      messageBus.subscribe(
        "common:RecoverGameListener",
        this.onRecoverGameListener.bind(this)
      );
      this._disclaimerFunc = this.onDisclaimerVisible.bind(this);
      this._introVisibleFunc = this.onIntroVisible.bind(this);
      this._waitForInputFunc = this.onWaitForInput.bind(this);
      this._handledCommand = this.onHandledCommand.bind(this);
    }

    onHandledCommand() {
      this._commandsToSend.shift();
    }

    onDisclaimerVisible() {
      messageBus.post("Gamble:OkDisclaimer");
    }

    onIntroVisible() {
      messageBus.post("Gamble:OfferGamble");
    }

    onWaitForInput() {
      let nextCommands = this._commandsToSend[0];

      if (nextCommands === undefined) {
        messageBus.postImmediate("Gamble:RemoveRecoveryFlag");
        this._task.leave();
        this._task = undefined;
      } else {
        if (nextCommands.indexOf("GAMBLE") !== -1) {
          timerManager.addTimeout(1000, () => {
            messageBus.postImmediate("Gamble:Risk", {
              data: { command: nextCommands },
            });
          });
        } else {
          messageBus.postImmediate("Gamble:ClickToContinue");
          messageBus.postImmediate("Gamble:Collect");
        }
      }
    }

    setupRecoveryGame(task) {
      this._task = task;
      this._task.join();

      this._commandsToSend = JSON.parse(
        JSON.stringify(this._task.data.previousCommands.slice(1))
      ); // ignore Base command

      messageBus.postImmediate("Gamble:GambleInit");

      messageBus.subscribe("Gamble:DisclaimerVisible", this._disclaimerFunc);
      messageBus.subscribe("Gamble:IntroVisible", this._introVisibleFunc);
      messageBus.subscribe("Gamble:WaitForInput", this._waitForInputFunc);
      messageBus.subscribe("Gamble:HandledCommand", this._handledCommand);
    }

    onRecoverGameListener(task) {
      // are their commands here that took us to the gamble game?
      let commands = task.data.previousCommands;

      let found = false;

      for (let i = 0; i < commands.length; ++i) {
        if (
          commands[i].indexOf("GAMBLE") !== -1 ||
          commands[i].indexOf("COLLECT") !== -1
        ) {
          this.setupRecoveryGame(task);
          found = true;
          break;
        }
      }

      if (!found) {
        messageBus.post("Gamble:RemoveRecoveryFlag");
      }
    }
  }

  resourceManager.registerController("GameRecoveryController", function () {
    return new GameRecoveryController();
  });
})();
